import React from 'react';
import { useTranslation } from 'react-i18next';
import Hero from './Hero';
import VideoSection from './VideoSection';
import About from './About';
import HowItWorks from './HowItWorks';
import Testimonials from './Testimonials';
import BlogPreview from './BlogPreview';
import Newsletter from './Newsletter';
import Community from './Community';
import FAQ from './FAQ';
import ProductShowcase from './ProductShowcase';

const Home = () => {
  const { t } = useTranslation();
  // Se quiser, adicione exemplos de t('...') para títulos, descrições etc.
  return (
    <div className="home-page">
      <Hero />
      <VideoSection />
      <About />
      <HowItWorks />
      <Testimonials />
      <BlogPreview />
      <Newsletter />
      <Community />
      <FAQ />
      <ProductShowcase />
    </div>
  );
};

export default Home;


